import PencilIcon from "@heroicons/react/24/solid/PencilIcon";
import TrashIcon from "@heroicons/react/24/solid/TrashIcon";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Chip,
} from "@mui/material";
import { FC } from "react";

import { PerfilCompleto } from "../../types";

interface TablePerfisProps {
  items: PerfilCompleto[];
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
  isLoading: boolean;
}

export const TablePerfis: FC<TablePerfisProps> = ({
  items,
  onEdit,
  onDelete,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="400px"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Card>
      <Box sx={{ minWidth: 800 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nome</TableCell>
              <TableCell>Painel</TableCell>
              <TableCell>Valor CSP</TableCell>
              <TableCell>URL</TableCell>
              <TableCell>Porta</TableCell>
              <TableCell>Tipo</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((perfil) => (
              <TableRow hover key={perfil.id}>
                <TableCell>{perfil.nome}</TableCell>
                <TableCell>{perfil.painelNome || "-"}</TableCell>
                <TableCell>{perfil.valorCsp}</TableCell>
                <TableCell>{perfil.url}</TableCell>
                <TableCell>{perfil.porta}</TableCell>
                <TableCell>{perfil.tipo}</TableCell>
                <TableCell>
                  <Chip
                    label={perfil.bloqueado === "S" ? "Bloqueado" : "Ativo"}
                    color={perfil.bloqueado === "S" ? "error" : "success"}
                    size="small"
                  />
                </TableCell>
                <TableCell>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Button
                      startIcon={
                        <SvgIcon fontSize="small">
                          <PencilIcon />
                        </SvgIcon>
                      }
                      size="small"
                      variant="contained"
                      color="primary"
                      onClick={() => onEdit(perfil.id!)}
                    >
                      Editar
                    </Button>
                    <Button
                      startIcon={
                        <SvgIcon fontSize="small">
                          <TrashIcon />
                        </SvgIcon>
                      }
                      size="small"
                      variant="contained"
                      color="error"
                      onClick={() => onDelete(perfil.id!)}
                    >
                      Excluir
                    </Button>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
            {items.length === 0 && (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  Nenhum perfil encontrado
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Box>
    </Card>
  );
};
